/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1901854786 — Інтеграція лояльності з оплатою */

import { CSSProperties } from 'react';

import {
    LoyaltyBalanceIcon,
    LoyaltyBanner,
    useGetLoyaltyBalance,
    useLoyaltyStore,
} from '..';
import { useTimerStore } from '../../../shared/hooks/useTimerStore';
import styles from './LoyaltyLayout.module.css';

/**
 * Component, that initialize loyalty program values in store.
 *
 * Optionally adding the loyalty balance (with fixed position)
 */
export function LoyaltyLayout({
    children,
    style,
    isBalanceEnabled = true,
    isBannerEnabled = true,
}: {
    children?: React.ReactNode;
    style?: CSSProperties;
    isBalanceEnabled?: boolean;
    isBannerEnabled?: boolean;
}) {
    const isLoyaltyProgramActive = useLoyaltyStore((state) =>
        state.isLoyaltyProgramActive(),
    );
    const isTimerVisible = useTimerStore((state) => state.isVisible);
    const isBalanceVisible = isLoyaltyProgramActive && isBalanceEnabled;

    useGetLoyaltyBalance({});

    // The timer sits in the top-right corner: offset the badge to clear it, or
    // let it sit flush right on screens without a timer (SWRN-1747).
    const balanceStyle: CSSProperties = style ?? {
        right: isTimerVisible ? 80 : 16,
    };

    return (
        <div className={styles.wrapper}>
            {isBalanceVisible && (
                <div className={styles.balanceIcon} style={balanceStyle}>
                    <LoyaltyBalanceIcon />
                </div>
            )}
            {children}
            {isBalanceEnabled && isBannerEnabled && <LoyaltyBanner />}
        </div>
    );
}
